import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/root/_services/storage.service';
import { SaveTempService } from 'src/app/root/_services/save-temp.service';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { Router } from '@angular/router';
import { delay } from 'rxjs/operators';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

	constructor(
		private storageService: StorageService,
		private saveTempService: SaveTempService,
		private authenticationService: AuthenticationService,
		private router: Router
	) { }

	logout() {
		let u = this.storageService.getItem("current_user");
		this.saveTempService.empty();
		this.authenticationService.logout(false).pipe(delay(0))
			.subscribe(
				data => this.returnToLogin(u),
				err => this.returnToLogin(u)
			);
	}

	returnToLogin(u: any) {
		if (u && "mkt" in u && u.mkt)
			this.router.navigate(['/booking/' + u.mkt + '/login']);
		else
			this.router.navigate(['/login']);
		this.authenticationService.clearClientSession();
	}

	ngOnInit() {
		this.logout();
	}

}
